import _taggedTemplateLiteral from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: inline-flex;\n        flex-direction: row;\n        align-items: baseline;\n\n        /* CSS API for host */\n        --vaadin-form-item-label-width: 8em;\n        --vaadin-form-item-label-spacing: 1em;\n        --vaadin-form-item-row-spacing: 1em;\n\n        margin: calc(0.5 * var(--vaadin-form-item-row-spacing)) 0;\n      }\n\n      :host([label-position=\"top\"]) {\n        flex-direction: column;\n        align-items: stretch;\n      }\n\n      #label {\n        width: var(--vaadin-form-item-label-width);\n        flex: 0 0 auto;\n      }\n\n      :host([label-position=\"top\"]) #label {\n        width: auto;\n      }\n\n      #spacing {\n        width: var(--vaadin-form-item-label-spacing);\n        flex: 0 0 auto;\n      }\n\n      #content {\n        flex: 1 1 auto;\n      }\n\n      #content ::slotted(.full-width) {\n        box-sizing: border-box;\n        width: 100%;\n        min-width: 0;\n      }\n    </style>\n    <div id=\"label\" part=\"label\" on-click=\"_onLabelClick\">\n      <slot name=\"label\" id=\"labelSlot\"></slot>\n    </div>\n    <div id=\"spacing\"></div>\n    <div id=\"content\">\n      <slot id=\"contentSlot\"></slot>\n    </div>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
/**
 * `<vaadin-form-item>` is a Web Component providing labelled form item wrapper
 * for using inside `<vaadin-form-layout>`.
 *
 * `<vaadin-form-item>` accepts any number of children as the input content,
 * and also has a separate named `label` slot:
 *
 * ```html
 * <vaadin-form-item>
 *   <label slot="label">Label aside</label>
 *   <input>
 * </vaadin-form-item>
 * ```
 *
 * Any content can be used. For instance, you can have multiple input elements
 * with surrounding text. The label can be an element of any type:
 *
 * ```html
 * <vaadin-form-item>
 *   <span slot="label">Date of Birth</span>
 *   <input placeholder="YYYY" size="4"> -
 *   <input placeholder="MM" size="2"> -
 *   <input placeholder="DD" size="2"><br>
 *   <em>Example: 1900-01-01</em>
 * </vaadin-form-item>
 * ```
 *
 * The label is optional and can be omitted:
 *
 * ```html
 * <vaadin-form-item>
 *   <input type="checkbox"> Subscribe to our Newsletter
 * </vaadin-form-item>
 * ```
 *
 * By default, the `label` slot content is displayed aside of the input content.
 * When `label-position="top"` is set, the `label` slot content is displayed on top:
 *
 * ```html
 * <vaadin-form-item label-position="top">
 *   <label slot="label">Label on top</label>
 *   <input>
 * </vaadin-form-item>
 * ```
 *
 * **Note:** Normally, `<vaadin-form-item>` is used as a child of
 * a `<vaadin-form-layout>` element. Setting `label-position` is unnecessary,
 * because the `label-position` attribute is triggered automatically by the parent
 * `<vaadin-form-layout>`, depending on its width and responsive behavior.
 *
 * ### Input Width
 *
 * By default, `<vaadin-form-item>` does not manipulate the width of the slotted
 * input elements. Optionally you can stretch the child input element to fill
 * the available width for the input content by adding the `full-width` class:
 *
 * ```html
 * <vaadin-form-item>
 *   <label slot="label">Label</label>
 *   <input class="full-width">
 * </vaadin-form-item>
 * ```
 *
 * ### Styling
 *
 * The `label-position` host attribute can be used to target the label on top state:
 *
 * <pre><code>
 * &lt;dom-module id="my-form-item-theme" theme-for="vaadin-form-item"&gt;
 *   &lt;template&gt;
 *     &lt;style&gt;
 *       :host {
 *         /&#42; default state styles, label aside &#42;/
 *       }
 *
 *       :host([label-position="top"]) {
 *         /&#42; label on top state styles &#42;/
 *       }
 *     &lt;/style&gt;
 *   &lt;/template&gt;
 * &lt;/dom-module&gt;
 * </code></pre>
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ---|---
 * label | The label slot container
 *
 * ### Custom CSS Properties Reference
 *
 * The following custom CSS properties are available on the `<vaadin-form-item>`
 * element:
 *
 * Custom CSS property | Description | Default
 * ---|---|---
 * `--vaadin-form-item-label-width` | Width of the label column when the labels are aside | `8em`
 * `--vaadin-form-item-label-spacing` | Spacing between the label column and the input column when the labels are aside | `1em`
 * `--vaadin-form-item-row-spacing` | Height of the spacing between the form item elements | `1em`
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @memberof Vaadin
 * @mixes Vaadin.ThemableMixin
 * @demo demo/index.html
 */

var FormItemElement =
/*#__PURE__*/
function (_ThemableMixin) {
  _inherits(FormItemElement, _ThemableMixin);

  function FormItemElement() {
    _classCallCheck(this, FormItemElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormItemElement).apply(this, arguments));
  }

  _createClass(FormItemElement, [{
    key: "_onLabelClick",
    value: function _onLabelClick(e) {
      // No `Array.prototype.find` in MSIE, using `filter` instead :-(
      var firstContentElementChild = Array.prototype.filter.call(this.$.contentSlot.assignedNodes(), function (e) {
        return e.nodeType === Node.ELEMENT_NODE;
      })[0];

      if (firstContentElementChild) {
        firstContentElementChild.focus();
        firstContentElementChild.click();
      }
    }
  }], [{
    key: "template",
    get: function get() {
      return html(_templateObject());
    }
  }, {
    key: "is",
    get: function get() {
      return 'vaadin-form-item';
    }
  }, {
    key: "properties",
    get: function get() {
      return {};
    }
  }]);

  return FormItemElement;
}(ThemableMixin(PolymerElement));

customElements.define(FormItemElement.is, FormItemElement);
export { FormItemElement };